import React from "react";
import { Row } from "react-bootstrap";
import { Table } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import CompareBody from "./compareBody1";

const Compare = () => {
  const { t } = useTranslation();

  return (
    <Row className="m-0 pb-3 w-100 d-flex justify-content-center ">
      <Row className="d-flex justify-content-center productSansBold text_36 text_xs_36 ">
        {t("CompareFeature")}
      </Row>
      <Row className="w-75 w-xs-100 px-4 mt-4 ">
        <Table className="m-0 comparison-table">
          <thead>
            <tr>
              <th className="border-0"></th>
              <th className="text-center productSansBold text_24 border-0 text_xs_24 w_20">
                {t("FreeTitle")}
              </th>
              <th className="text-center productSansBold text_24 border-0 text_xs_24 w_20">
                {t("PremTitle")}
              </th>
              <th className="text-center productSansBold text_24 border-0 text_xs_24 w_20 border-0">
                {t("EnterpriseTitle")}
              </th>
            </tr>
          </thead>
          <tbody>
            <CompareBody
              name={"SingleImageWatermark"}
              free={true}
              prem={true}
              enter={true}
            />
            <CompareBody
              name={"BatchWatermark"}
              free={true}
              prem={true}
              enter={true}
            />
            <CompareBody
              name={"TemplateCreation"}
              free={false}
              prem={true}
              enter={true}
            />
          </tbody>
        </Table>
      </Row>
    </Row>
  );
};

export default Compare;
